<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import { dateFormat } from "@/core/services/helpers"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  import SeasonalityForm from "@/domains/lines/views/seasonalities/partials/SeasonalityForm.vue"

  export default {
    components: {
      Breadcrumbs,
      SeasonalityForm,
    },
    data: () => {
      return {
        locale: ptBR,
        dateFormat,
        title: "Nova Sazonalidade",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Sazonalidades",
            path: "lines.seasonalities",
          },
          {
            name: "Nova Sazonalidade",
            path: "lines.seasonalities.create",
          },
        ],
        seasonality: {
          desazonalidade: "",
          infosazonalidade: "",
          dtinicio: "",
          dtfim: "",
        },
      }
    },
    methods: {
      submit() {
        this.$axios
          .post("/api/lines/seasonality", this.seasonality)
          .then(() => {
            this.$toast.success({
              title: "OK",
              message: "Sazonalidade Cadastrada com Sucesso",
            })
            this.$router.push({ name: "lines.seasonalities" })
          })
          .catch((error) => {
            this.$toast.error({
              title: "Erro",
              message: error.response.data.error,
            })
          })
      },
    },
  }
</script>
<style>
  .date-picker-seasonality > .vdp-datepicker__calendar {
    width: 100% !important;
  }
</style>

<template>
  <div class="w-full bg-white">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Cadastro de Sazonalidade</h1>
      </div>
      <SeasonalityForm :seasonality="seasonality" @submit="submit"/>
    </div>
  </div>
</template>
